"use client";

import { useMediaQuery } from "@mantine/hooks";
import { ScrollView } from "react95";
import { ThjPage } from "@/components/partners/thj/thj-page";
import MobilePage from "@/components/ui/mobile-page";

export default function Page() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isSmallScreen === true && <MobilePage disabled={false} />}
      {isSmallScreen === false && <ThjPage />}
    </>
  );
}
